/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';
import { type TagEntity, tagSchema } from '@axiom/domain';
import { TagType } from '../../../enums/generated/tag-type';

/** ReadTagsResponse — dark-roast DTO: GetTagsResponseDto; also used by readTagsService, readTagsName, readTagsSystemEvents */
export const readTagsResponseSchema = tagSchema.pick({ "id": true, "name": true, "parentId": true }).extend({ "type": z.nativeEnum(TagType).nullish() });
export type ReadTagsResponse = Pick<TagEntity, "id" | "name" | "parentId"> & z.infer<typeof readTagsResponseSchema>;
